export const getInitialState = (): any => ({
  authData: {},
  authStatus: 0
});
